module.exports = __webpack_public_path__ + "assets/img/00009.9e927de0.png";